module.exports = __webpack_public_path__ + "static/media/106.5b88bf54.jpg";